var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff4F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91.64 178.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c5a07d;}.cls-2{fill:#dcb998;}.cls-3{fill:#f2dac5;}.cls-4,.cls-6,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;}.cls-4{stroke:#dcb998;}.cls-5{fill:#ded6ce;}.cls-6{stroke:#a3866a;}.cls-7{stroke:#f2dac5;}.cls-8{stroke:#fdebdd;}.cls-9{fill:#14adb2;}.cls-10{fill:#232323;}.cls-11{fill:#004568;}.cls-12{fill:#0e5279;}.cls-13{fill:#1199a1;}.cls-14{fill:#f3b792;}.cls-15{fill:#50290a;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Box_01a",
    "data-name": "Box_01a",
    viewBox: "0 0 87.2 93.25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.25 15.67 40.15 38.7 40.15 92.7 0.25 69.67 0.25 15.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.7 23.58 40.15 38.7 40.15 92.7 86.7 77.58 86.7 23.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.25 15.67 40.15 38.7 86.7 23.58 46.8 0.54 0.25 15.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.49,
    y1: 8.12,
    x2: 63.39,
    y2: 31.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "20.2 33.19 33.5 40.87 33.5 52.87 20.2 45.19 20.2 33.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 40.15,
    y1: 38.7,
    x2: 40.15,
    y2: 92.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "86.7 77.58 40.15 92.7 0.25 69.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 86.7,
    y1: 23.58,
    x2: 86.7,
    y2: 77.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "0.25 15.67 46.8 0.54 86.7 23.58"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_02a",
    "data-name": "Staff_Male_02a",
    viewBox: "0 0 91.64 178.24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.69,27.05c4-.6,9.31,4,10,12.19l.67,8.2L39.92,50.1C38.36,45.67,32.38,28.16,39.69,27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.13,167.16c-.22,2.44-1.55,6.65.67,7.09s4.43,0,6.43.89,6,3.1,9.75,3.1,7.76-1.55,3.33-4-8.65-4.21-10.64-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M28.17,101.09c2.66,7.54,8.86,17.29,9.53,25.5s2.88,37.69,2.88,40.12,12.86,6,12.64.89S51.22,132.35,51,127s-4.43-43.45-4.43-43.45l-17.52,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11.54,164.28a29.38,29.38,0,0,0,2,8.86c2.44,5.55-6.2,6.88-9.09,1.78-3.07-5.44-.88-11.53-.88-11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M32.16,88c0,3.11-1.78,15.08-4.88,23.95s-6.43,17.51-7.54,23.5-6,24.6-6.87,29.26-8.65,5.54-9.31-1.33,3-24.91,4.87-32.81c1.78-7.32,2.67-16.41,3.11-25.5s1.11-22.83,1.11-22.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27.06,28.38c7.09-2,15.74-2.89,18.18,4.43,2.28,6.85,1.33,45.89,1.33,50.77S33.26,91.12,29.5,91.34,12.87,90.67,12,87.79s-3.1-40.13-2.66-47S14.29,32,27.06,28.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.62,26.82s-2.88,1.56-3.32,4,8.87,9.31,8.87,9.31l4.21-5.55L39,37.69s-3.1-9.53-5.1-10.64A11.39,11.39,0,0,0,22.62,26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M23.07,28.82l.22-4.66c-3.77-2.21-5.88-5.53-5.54-11.3.22-3.77,4-9.53,8.64-9.53S39.25,5,39.69,13.41s-.66,17.18-6.2,15l-1.11,6.2C31.49,34.81,23.51,31.7,23.07,28.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M24.62,17.07c-1.33-1.77-3.77-.89-3.77,1.77a4,4,0,0,0,2.66,3.55l-.22,1.77s-5-1.1-6.32-8.2C15.31,7,19.19,0,27.39,0,36.7,0,41.8,6.21,41.8,12.53c0,6-15,1.22-16.74-.34C24.84,14.19,24.62,17.07,24.62,17.07Z"
  }), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(21.88 32.09) scale(0.8)",
    xlinkHref: "#Box_01a"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M12.2,52.76c-.88,4.66-1.55,8.87-1.55,8.87S25.06,72.94,27.5,73.16s7.09,0,7.09,0,7.1.44,7.1,1.55-6.43,1.33-7.1,2,1.56,2.88,3.55,3.32,4,1.11,4,2.22-.66,3.32-2.88,3.32-5.76,0-7.76-.88-4.88-5.1-6.87-6S13.09,76,8.88,74.05.23,68.28,0,66.51,3.11,51,3.11,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.1,35c7.2.9,5.76,7.76,5.09,11.08S14,53,13.31,55.65,1.34,57,1.56,53,5.77,34.36,11.1,35Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 91.64,
    height: 178.24,
    xlinkHref: "#Staff_Male_02a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff4F);
export default __webpack_public_path__ + "static/media/staff-4-f.1384dfa1638bf21192cabce419d429bc.svg";
export { ForwardRef as ReactComponent };